import { Card, CardTitle } from "../../components/Card";
import { HeaderContent } from "../../components/Header";
import "./styles.scss";

export const ContentDetailsScreen = ({ data, columns }) => {
  return <Card className="no-border">
    <div className="content-details-container" style={{ width: "100%" }}>
      <HeaderContent>
        <CardTitle title="Detalhes do conteúdo" />
      </HeaderContent>
      <div className="content-questions-container">
        <div className="content-questions-table">
          <table>
            <tbody>
              {columns && Array.isArray(columns) &&
                columns.map((column, index) => (
                  <tr>
                    <td className={index % 2 !== 0 ? "white__line" : "td-questions"}>
                      {column?.title}
                    </td>
                    <td className={index % 2 !== 0 ? "white__line" : "td-questions"}>
                      {data[column?.code] || ''}
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Card>
}